<app-dashboard-header></app-dashboard-header>

<div class="container-xxl">
  <main>
    <br>    
    <div class="container">      
      <form class="mt-5 mb-5" method="post">
        <div class="content row">

          <!-- <div class="col-md-3">
            <div class="session-image">
              <img class="img-fluid" src="">
            </div>
          </div> -->
          
          <div class="col-md-9">
            <div class="">
                <div class="row">
                  <div class="col-md-4">
                    <label>رقـــم الحلقة</label>
                  </div>
                  <div class="text col-md-8">
                    <p>{{ session.sessionNumber }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label>المجموعة</label>
                  </div>
                  <div class="text col-md-8">
                    <p>{{ session.classId }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label>بداية الحلقة</label>
                  </div>
                  <div class="text col-md-8">
                    <p>{{ session.startTime |  date :'short'}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label>نهايـــة الحلقة</label>
                  </div>
                  <div class="text col-md-8">
                    <p>{{ session.endTime |  date :'short'}}</p>
                  </div>
                </div>
                
                <!-- <div class="buttons">
                  <a class="update btn btn-warning" routerLink="/updateSession/{{ id }}">التعديــــل</a> &nbsp; &nbsp; &nbsp;
                  <a class="delete btn btn-secondary" (click)="delete()">الحـــذف</a>                                 
                </div> -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <br>
  </main>
</div>

<app-dashboard-footer></app-dashboard-footer>
